import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requirePartner = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '20px'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/WelcomePage" replace />;
  }

  if (requireAdmin && user.type !== 'admin') {
    return <Navigate to="/WelcomePage" replace />;
  }

  if (requirePartner && user.type !== 'partner') {
    return <Navigate to="/WelcomePage" replace />;
  }

  return children;
};

export default ProtectedRoute;